import { render, staticRenderFns } from "./PageWithdraw.vue?vue&type=template&id=2957a75b&scoped=true"
import script from "./PageWithdraw.vue?vue&type=script&lang=js"
export * from "./PageWithdraw.vue?vue&type=script&lang=js"
import style0 from "./PageWithdraw.vue?vue&type=style&index=0&id=2957a75b&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2957a75b",
  null
  
)

export default component.exports